interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  phone?: string;
  whatsapp?: string;
}

export function EmptyState({ icon, title, description, phone, whatsapp }: EmptyStateProps) {
  const hasCTA = phone || whatsapp;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center">
      {icon && (
        <div className="text-5xl mb-4" aria-hidden="true">
          {icon}
        </div>
      )}
      <h2 className="text-xl font-semibold text-gray-900 mb-2">{title}</h2>
      <p className="text-gray-500 max-w-sm">{description}</p>

      {hasCTA && (
        <div className="mt-6 flex flex-col sm:flex-row gap-3">
          {whatsapp && (
            <a
              href={`https://wa.me/${whatsapp.replace(/\D/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-[var(--radius)] text-white text-sm font-medium transition-opacity hover:opacity-90"
              style={{ backgroundColor: "#25d366" }}
            >
              <span aria-hidden="true">💬</span>
              WhatsApp us
            </a>
          )}
          {phone && (
            <a
              href={`tel:${phone}`}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-[var(--radius)] text-white text-sm font-medium transition-opacity hover:opacity-90"
              style={{ backgroundColor: "var(--accent)" }}
            >
              <span aria-hidden="true">📞</span>
              Call us
            </a>
          )}
        </div>
      )}
    </div>
  );
}
